import { Component } from '@angular/core';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { Group } from '../_types/group';
import { GroupsService } from '../_services/groups.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { firstValueFrom } from 'rxjs';
import { TabViewChangeEvent } from 'primeng/tabview';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { GroupUsersService } from '../_services/groups-users.service';
import { DialogService } from 'primeng/dynamicdialog';
import { GroupUserComponent } from './group-user/group-user.component';
import { UsersService } from '../../users/_services/users.service';

@Component({
    selector: 'app-groups-detail',
    templateUrl: './groups-detail.component.html',
    styleUrls: ['./groups-detail.component.scss'],
    standalone: false
})
export class GroupsDetailComponent {
  public groupFormGroup!: RxFormGroup;

  public group: Group = new Group();
  public users: any[] = [];
  public responsibles: any[] = [];

  public totalUsersRecords: number = 0;

  public allowWrite: boolean = false;
  public allowDelete: boolean = false;
  public activeIndex: number = 0;

  constructor(
    private groupsService: GroupsService,
    private groupUsersService: GroupUsersService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private route: ActivatedRoute,
    private router: Router,
    private topbarService: TopbarService,
    private formBuilder: RxFormBuilder,
    private formValidationService: FormValidatorService,
    private dialogService: DialogService,
    private usersService: UsersService
  ) {

    this.groupFormGroup = this.formBuilder.formGroup<Group>(this.group) as RxFormGroup;
  }

  async ngOnInit() {
    this.topbarService.setTitle("Detalles de grupo");
    this.topbarService.addBreadcrumb("Grupos", "/groups");
    let id = this.route.snapshot.params['guid'];
    if (id != null && id != '0') {
      await this.loadGroup(id);
    }

    this.allowWrite = true;//this.loginService.hasPermission("PROVIDERS_WRITE");
    this.allowDelete = true;//this.loginService.hasPermission("PROVIDERS_DELETE");

    this.loadResponsibles();
  }

  async loadGroup(id: string) {
    this.group = await firstValueFrom(this.groupsService.get(id));
    this.groupFormGroup.patchValue(this.group);

    this.loadUsers();
  }

  async onTabChange(event: TabViewChangeEvent) {
    if (event.index == 0) {
      //users
    }
  }

  async loadResponsibles() {

    let filters = {
      isWorker: new Filter(FilterOperation.equals, 'isWorker', "", false)
    };    

    let params: IParamsCollection = {      
      filter: FilterBuilder.fromObject(filters).build()
    }      

    let response = await firstValueFrom(this.usersService.all(params));    

    this.responsibles = response.data;    
  }

  async loadUsers() {
    let filters = {
      groupId: new Filter(FilterOperation.equals, 'groupId', "", this.group.id)
    };

    let params: IParamsCollection = {
      include: ['user']
    }

    //creamos filtros
    params.filter = FilterBuilder.fromObject(filters).build();

    let response = await firstValueFrom(this.groupUsersService.all(params));

    this.users = response.data;
    this.totalUsersRecords = response.meta['total'];
  }

  async save() {
    let valid = this.formValidationService.validateForm(this.groupFormGroup);
    if (valid) {
      this.group = Object.assign(this.group, this.groupFormGroup.value);

      //guardamos operario
      let group = await firstValueFrom(this.groupsService.save(this.group));

      this.messageService.add({ closable: true, severity: 'success', summary: "Grupo guardado correctamente." });


      this.router.navigate(['groups']);


    } else {
      this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "Existen errores, por favor revise el formulario de datos." });
    }
  }

  async delete() {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar el grupo " + this.group.name + "?",
      header: "Eliminar grupo",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.groupsService.delete(this.group.id).subscribe({
          next: (data: any) => {
            this.cancel();
            this.messageService.add({ closable: true, severity: 'success', detail: "Grupo eliminado correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      },
      reject: (error: any) => {
        this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });
  }

  addUser() {
    const ref = this.dialogService.open(GroupUserComponent, {
      closable: true,
      modal: true,
      data: {
        existentUsers: this.users,
        groupId: this.group.id
      },
      header: "Asignar usuario",
      width: '40%'
    });
    ref.onClose.subscribe((data: any) => {
      this.loadUsers();
    });
  }

  deleteUser(groupUser: any) {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea desasignar el usuario " + groupUser.user?.name + "?",
      header: "Desasignar usuario",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.groupUsersService.delete(groupUser.id).subscribe({
          next: (data: any) => {
            this.loadUsers();
            this.messageService.add({ closable: true, severity: 'success', detail: "Usuario desasignado correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      },
      reject: (error: any) => {
        this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });

  }

  cancel() {
    this.router.navigate(['groups']);
  }

}
